import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Sanitizes error messages to prevent large HTML blobs or sensitive data from being logged.
 * Especially useful for Supabase/Cloudflare 522/504 errors.
 */
export function sanitizeError(error: any): string {
  if (!error) return "Unknown error";
  
  const message = error.message || (typeof error === 'string' ? error : JSON.stringify(error));
  
  if (typeof message === 'string' && message.includes('<!DOCTYPE html>')) {
    // Check for common Cloudflare error codes in the HTML
    if (message.includes('Error code 522')) return "Connection timed out (Error 522)";
    if (message.includes('Error code 504')) return "Gateway timeout (Error 504)";
    if (message.includes('Error code 520')) return "Unknown error (Error 520)";
    
    return "Received HTML error page instead of JSON response";
  }
  
  return message;
}
